package com.trevorwiebe.timesheet.core.domain.dto

import kotlinx.serialization.Serializable

@Serializable
data class OrganizationDto(
    val name: String,
    val goLiveDate: String,
    // Printed in the invoice PDF header.
    val billingAddress: String = "",
    val billingPhone: String = "",
    val billingEmail: String = "",
    val remitTo: String = "",
)
